import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';

import { SelectedProductsEffects } from '@app/pricing/store/selected-products.effects';
import { SelectedProductsFeature } from '@app/pricing/store/selected-products.slice';
import { VipDiscountsEffects } from '@app/vip-discounts/store/vip-discounts.effects';
import { VipDiscountsFeature } from '@app/vip-discounts/store/vip-discounts.slice';
import { VipDiscountsModule } from '@app/vip-discounts/vip-discounts.module';
import { SharedModule } from '@shared/shared.module';

import { VipDiscountsContainerComponent } from './containers/vip-discounts-container/vip-discounts-container.component';
import { VipDiscountsWithSearchComponent } from './containers/vip-discounts-with-search/vip-discounts-with-search.component';
import { VipDiscountsGivenTableComponent } from './pages/vip-discounts-given/vip-discounts-given-table/vip-discounts-given-table.component';
import { VipDiscountsGivenComponent } from './pages/vip-discounts-given/vip-discounts-given.component';
import { VipDiscountsPartnersComponent } from './pages/vip-discounts-products-and-partners/vip-discounts-partners/vip-discounts-partners.component';
import { VipDiscountsProductsAndPartnersComponent } from './pages/vip-discounts-products-and-partners/vip-discounts-products-and-partners.component';
import { VipDiscountsSettingsTableComponent } from './pages/vip-discounts-settings/vip-discounts-settings-table/vip-discounts-settings-table.component';
import { VipDiscountsSettingsComponent } from './pages/vip-discounts-settings/vip-discounts-settings.component';
import { VipDiscountsSellingEffects } from './store/vip-discounts-selling.effects';
import { VipDiscountsSellingFeature } from './store/vip-discounts-selling.slice';
import { VipDiscountsSellingRoutingModule } from './vip-discounts-selling-routing.module';

@NgModule({
  declarations: [
    VipDiscountsContainerComponent,
    VipDiscountsWithSearchComponent,
    VipDiscountsGivenComponent,
    VipDiscountsProductsAndPartnersComponent,
    VipDiscountsPartnersComponent,
    VipDiscountsGivenTableComponent,
    VipDiscountsSettingsComponent,
    VipDiscountsSettingsTableComponent,
  ],
  imports: [
    CommonModule,
    VipDiscountsSellingRoutingModule,
    TranslateModule,
    SharedModule,
    StoreModule.forFeature(SelectedProductsFeature),
    StoreModule.forFeature(VipDiscountsFeature),
    StoreModule.forFeature(VipDiscountsSellingFeature),
    EffectsModule.forFeature([
      VipDiscountsEffects,
      VipDiscountsSellingEffects,
      SelectedProductsEffects,
    ]),
    VipDiscountsModule,
  ],
})
export class VipDiscountsSellingModule {}
